const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 404.93,
    height: 343.84,
    viewBox: "0 0 107.138 90.974",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9d4f3"
    },
    d: "m73.62 313.32-28.43-16.41v-60.98l28.43 16.42z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3e3fa"
    },
    d: "m73.62 252.35 40.62-23.45v60.97l-40.62 23.45z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5fd"
    },
    d: "m114.24 228.9-40.62 23.45-28.43-16.42 40.62-23.45z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9d4f3"
    },
    d: "m78.43 277.71-.75-.43.01-22.59 32.49-18.76.75.43v22.59z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5fd"
    },
    d: "m78.43 255.13 32.5-18.77v22.59l-32.5 18.76z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9d4f3"
    },
    d: "m91.17 251.6 5.53-3.19c.71-.42 1.29-.23 1.29.42a2.59 2.59 0 0 1-1.29 1.92l-5.53 3.19c-.72.42-1.3.23-1.3-.42a2.58 2.58 0 0 1 1.3-1.92zM77.68 306.29l-.74-.43v-22.59l32.49-18.76v22.59l.75.43z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5fd"
    },
    d: "m77.68 283.7 32.5-18.76v22.59l-32.5 18.76z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9d4f3"
    },
    d: "M90.42 280.18 96 277c.72-.42 1.3-.23 1.3.42a2.58 2.58 0 0 1-1.3 1.92l-5.53 3.19c-.72.42-1.3.23-1.3-.42a2.58 2.58 0 0 1 1.25-1.93zM73.62 248.83l-28.43-16.42v-60.97l28.43 16.41z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3e3fa"
    },
    d: "m73.62 187.85 40.62-23.45v60.98l-40.62 23.45z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5fd"
    },
    d: "m114.24 164.4-40.62 23.45-28.43-16.41 40.62-23.45z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9d4f3"
    },
    d: "m78.43 213.22-.75-.44V190.2l32.5-18.76.75.43v22.59z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9d4f3"
    },
    d: "m91.17 187.1 5.52-3.19c.72-.41 1.3-.22 1.3.43a2.6 2.6 0 0 1-1.3 1.92l-5.52 3.19c-.72.41-1.3.23-1.3-.42a2.61 2.61 0 0 1 1.3-1.93zM77.68 241.79l-.74-.43v-22.58l32.49-18.76v22.58l.75.43z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5fd"
    },
    d: "m77.68 219.21 32.5-18.76v22.58l-32.5 18.76z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9d4f3"
    },
    d: "m90.42 215.68 5.58-3.19c.71-.41 1.3-.22 1.3.43a2.64 2.64 0 0 1-1.3 1.92L90.42 218c-.72.41-1.3.22-1.3-.42a2.61 2.61 0 0 1 1.3-1.9zM77.68 190.2l32.5-18.76v22.58l-32.5 18.76z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9d4f3"
    },
    d: "m126.43 182.6-17.79-10.27v19.9l17.79 10.26z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3e3fa"
    },
    d: "M118.3 173.78v25.8L89.87 216v-28.15l6.97-4.04 1.15 1.7z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5fd"
    },
    d: "m89.87 216 2.03-24.63 28.43-16.41-2.03 24.62z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3e3fa"
    },
    d: "m93.93 201.36-15.5-8.95v19.9l15.5 8.94z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5fd"
    },
    d: "m93.93 199.58 32.5-18.76v22.58l-32.5 18.76z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9d4f3"
    },
    d: "m106.67 196.05 5.52-3.19c.72-.41 1.3-.22 1.3.43a2.61 2.61 0 0 1-1.3 1.92l-5.52 3.19c-.72.41-1.3.22-1.3-.42a2.61 2.61 0 0 1 1.3-1.93zM93.93 199.58l-1.08-.62v22.58l1.08.62z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3e3fa"
    },
    d: "m92.85 198.96 32.49-18.77 1.09.63-32.5 18.76z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9d4f3"
    },
    d: "m409.5 276.38-28.44-16.42v-60.97l28.44 16.41z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3e3fa"
    },
    d: "m409.5 215.4 40.62-23.45v60.98l-40.62 23.45z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5fd"
    },
    d: "M450.12 191.95 409.5 215.4l-28.44-16.41 40.63-23.46z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9d4f3"
    },
    d: "m414.31 240.76-.75-.43v-22.58l32.5-18.76.75.43-.01 22.58z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5fd"
    },
    d: "m414.31 218.18 32.5-18.76-.01 22.58-32.49 18.76z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9d4f3"
    },
    d: "m427.05 214.65 5.52-3.19c.72-.41 1.3-.22 1.3.42a2.61 2.61 0 0 1-1.3 1.93l-5.52 3.19c-.72.41-1.3.22-1.3-.42a2.61 2.61 0 0 1 1.3-1.93zM413.56 269.34l-.75-.43v-22.58l32.5-18.77v22.59l.75.43z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5fd"
    },
    d: "m413.56 246.76 32.5-18.76v22.58l-32.5 18.76z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9d4f3"
    },
    d: "m426.3 243.23 5.53-3.19c.71-.41 1.29-.22 1.29.42a2.63 2.63 0 0 1-1.29 1.93l-5.53 3.19c-.72.41-1.3.22-1.3-.43a2.61 2.61 0 0 1 1.3-1.92z",
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-462.702 246.076s.03-4.197-2.616-7.343c-2.342-2.786-3.588-4.553-2.85-5.368.738-.815 2.326-1.01 4.466 1.244s2.307 8.498 2.011 9.91z",
    style: {
      fill: "#d6d5f4",
      strokeWidth: 0.26458332
    },
    transform: "translate(487.522 -173.418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-462.702 246.076s.03-4.197-2.616-7.343c-2.342-2.786-3.588-4.553-2.85-5.368.738-.815 2.326-1.01 4.466 1.244s2.307 8.498 2.011 9.91z",
    style: {
      opacity: 0.1,
      strokeWidth: 0.26458332
    },
    transform: "translate(487.522 -173.418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-462.257 241.564a.132.132 0 0 1-.13-.103c-.926-4.331-3.302-6.725-4.638-7.768a.132.132 0 0 1-.024-.185.135.135 0 0 1 .188-.024c1.363 1.058 3.789 3.508 4.734 7.922a.13.13 0 0 1-.101.156z",
    style: {
      fill: "#fff",
      strokeWidth: 0.26458332
    },
    transform: "translate(487.522 -173.418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-462.802 247.634-1.077.622a1.947 1.947 0 0 0-1.45-1.241c-1.177-.265-2.4-.22-3.225-1.241-.826-1.021.18-2.133 0-2.884-.18-.751-.297-.968-1.773-1.72-1.476-.751-2.058-1.997-.947-2.841 1.111-.844 2.91-.225 4 .529.969.661 1.89.836 2.972.97 1.082.136 2.844.736 2.574 3.25a19.807 19.807 0 0 1-1.074 4.556z",
    style: {
      fill: "#5b25f5",
      fillOpacity: 1,
      strokeWidth: 0.26458332
    },
    transform: "translate(487.522 -173.418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-466.935 244.332a.135.135 0 0 1-.127-.093.135.135 0 0 1 .087-.166c.096-.03 2.382-.754 3.353.024a.132.132 0 0 1-.164.206c-.858-.688-3.085.016-3.11.024z",
    style: {
      fill: "#fff",
      strokeWidth: 0.26458332
    },
    transform: "translate(487.522 -173.418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-462.683 247.433a.13.13 0 0 1-.13-.116c-.59-5.573-7.302-8.216-7.368-8.242a.132.132 0 0 1-.077-.172.135.135 0 0 1 .17-.077c.07.03 6.931 2.728 7.537 8.467a.132.132 0 0 1-.116.145z",
    style: {
      fill: "#fff",
      strokeWidth: 0.26458332
    },
    transform: "translate(487.522 -173.418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-396.873 243.975c.029-.093 1.164-5.935 0-10.078-1.059-3.8-2.44-5.202-4.408-5.511-1.969-.31-2.823 1.108-1.778 3.03 1.045 1.92 3.561 4.468 4.178 8.76.264 1.767.465 3.301.465 3.301z",
    style: {
      fill: "#d6d5f4",
      strokeWidth: 0.26458332
    },
    transform: "translate(487.522 -173.418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-396.873 243.975c.029-.093 1.164-5.935 0-10.078-1.059-3.8-2.44-5.202-4.408-5.511-1.969-.31-2.823 1.108-1.778 3.03 1.045 1.92 3.561 4.468 4.178 8.76.264 1.767.465 3.301.465 3.301z",
    style: {
      opacity: 0.1,
      strokeWidth: 0.26458332
    },
    transform: "translate(487.522 -173.418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-397.537 240.62a.132.132 0 0 1-.125-.14c.265-4.731-1.28-8.954-4.05-11.026a.132.132 0 0 1-.027-.185.135.135 0 0 1 .185-.026c2.84 2.116 4.432 6.434 4.154 11.253a.132.132 0 0 1-.137.124z",
    style: {
      fill: "#fff",
      strokeWidth: 0.26458332
    },
    transform: "translate(487.522 -173.418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-393.828 247.018c-.15-1.088.474-2.718 1.958-3.104 1.484-.386 2.146-1.238 1.611-2.17-.534-.93-.41-1.786.937-2.172 1.347-.386 2.527-1.058 1.751-2.482-.563-1.029-.687-1.696.694-3.722 1.145-1.683.209-2.67-1.225-2.485-1.434.185-2.32 1.895-3.218 2.18-.897.286-1.103-1.238-2.286-.555-1.182.682-1.11 2.431-1.148 3.651-.037 1.22-.116 1.495-1.185 1.347-1.07-.148-2.117.026-2.093 2.611.018 2.217 1.201 4.964 1.201 4.964z",
    style: {
      fill: "#5b25f5",
      fillOpacity: 1,
      strokeWidth: 0.26458332
    },
    transform: "translate(487.522 -173.418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-395.704 245.364h-.013a.135.135 0 0 1-.12-.148c.747-6.665 6.467-12.288 7.96-13.428a.133.133 0 0 1 .161.212c-1.474 1.124-7.12 6.673-7.856 13.245a.135.135 0 0 1-.132.119z",
    style: {
      fill: "#fff",
      strokeWidth: 0.26458332
    },
    transform: "translate(487.522 -173.418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-393.095 238.239a.135.135 0 0 1-.124-.085.138.138 0 0 1 .079-.172c2.133-.794 4.55-.418 4.654-.402a.132.132 0 0 1 .108.15.138.138 0 0 1-.15.112c-.024 0-2.453-.381-4.52.389a.15.15 0 0 1-.047.008zM-394.995 242.244a.132.132 0 0 1-.098-.045 7.8 7.8 0 0 1-1.743-3.616.132.132 0 0 1 .11-.151.132.132 0 0 1 .152.11 7.646 7.646 0 0 0 1.68 3.48.135.135 0 0 1-.1.222z",
    style: {
      fill: "#fff",
      strokeWidth: 0.26458332
    },
    transform: "translate(487.522 -173.418)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)",
    style: {
      fill: "#d6d5f4"
    },
    d: "M162.99 205.3v154.79l158.42-91.47V127.91l-117.8 68.01-4.06-11.73z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)",
    style: {
      opacity: 0.1
    },
    d: "M162.99 205.3v154.79l158.42-91.47V127.91l-117.8 68.01-4.06-11.73z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)",
    style: {
      fill: "#fff",
      fillOpacity: 1
    },
    d: "m329.53 127.91-8.12 140.71-158.42 91.47 8.12-140.72z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)",
    style: {
      fill: "#d6d5f4"
    },
    d: "m333.59 130.25-12.18 138.37-158.42 91.47 12.18-138.37z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)",
    style: {
      opacity: 0.1
    },
    d: "m333.59 130.25-12.18 138.37-158.42 91.47 12.18-138.37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-420.897 264.393c-7.525-4.345-14.505-9.068-17.69-14.608l9.683-5.59z",
    style: {
      fill: "#d9d4f3",
      strokeWidth: 0.26458332
    },
    transform: "translate(487.522 -173.418)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)",
    style: {
      fill: "#d6d5f4"
    },
    d: "M191.42 221.72V376.5l158.42-91.46V144.33l-117.8 68.01-4.06-11.73z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)",
    style: {
      opacity: 0.05
    },
    d: "M191.42 221.72V376.5l158.42-91.46V144.33l-117.8 68.01-4.06-11.73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-436.757 226.859c-.105 0-.121-.122-.121-.193V191.74a.878.878 0 0 1 .391-.678l30.253-17.462a.28.28 0 0 1 .137-.042c.106 0 .122.121.122.193v34.925a.881.881 0 0 1-.392.68l-30.252 17.462a.288.288 0 0 1-.138.04z",
    style: {
      fill: "#fff",
      strokeWidth: 0.26458332
    },
    transform: "translate(487.522 -173.418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-406.113 173.68a.265.265 0 0 1 0 .059v34.925a.76.76 0 0 1-.325.566l-30.252 17.462-.053.024a.161.161 0 0 1 0-.058v-34.925a.76.76 0 0 1 .325-.564l30.253-17.462a.148.148 0 0 1 .055-.024m.016-.265a.413.413 0 0 0-.204.061l-30.252 17.463a1.019 1.019 0 0 0-.458.793v34.925c0 .207.103.326.265.326a.407.407 0 0 0 .203-.061l30.253-17.463a1.008 1.008 0 0 0 .458-.793v-34.925c0-.207-.104-.328-.265-.326z",
    style: {
      fill: "#d6d5f4",
      strokeWidth: 0.26458332
    },
    transform: "translate(487.522 -173.418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-406.113 173.68a.265.265 0 0 1 0 .059v34.925a.76.76 0 0 1-.325.566l-30.252 17.462-.053.024a.161.161 0 0 1 0-.058v-34.925a.76.76 0 0 1 .325-.564l30.253-17.462a.148.148 0 0 1 .055-.024m.016-.265a.413.413 0 0 0-.204.061l-30.252 17.463a1.019 1.019 0 0 0-.458.793v34.925c0 .207.103.326.265.326a.407.407 0 0 0 .203-.061l30.253-17.463a1.008 1.008 0 0 0 .458-.793v-34.925c0-.207-.104-.328-.265-.326z",
    style: {
      opacity: 0.7,
      fill: "#fff",
      strokeWidth: 0.26458332
    },
    transform: "translate(487.522 -173.418)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)",
    style: {
      fill: "#d6d5f4"
    },
    d: "m288.91 163.21-40.62 23.45v-46.9l40.62-23.45z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)",
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "m288.91 163.21-40.62 23.45v-46.9l40.62-23.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-424.65 189.955v3.73l-.338.188v-1.14c0-.63-.51-.844-1.146-.479l-4.553 2.633c-.632.365-1.146 1.172-1.146 1.801v1.14l-.336.202v-3.723z",
    style: {
      fill: "#fff",
      strokeWidth: 0.26458332
    },
    transform: "translate(487.522 -173.418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-426.718 199.453c-.55.318-.998-.016-.998-.748v-5.972l-1.384.751v6.02c0 .73-.447 1.587-.997 1.897l-1 .577v.396l5.374-3.103v-.394z",
    style: {
      fill: "#fff",
      strokeWidth: 0.26458332
    },
    transform: "translate(487.522 -173.418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-420.897 186.25c0 .345.31.443.687.226l10.457-6.046a1.381 1.381 0 0 0 .688-1.019c0-.341-.31-.442-.688-.222l-10.449 6.032a1.376 1.376 0 0 0-.695 1.03zM-420.897 189.955c0 .344.31.444.687.225l10.449-6.033a1.381 1.381 0 0 0 .688-1.018c0-.342-.31-.442-.688-.223l-10.449 6.033a1.381 1.381 0 0 0-.687 1.016zM-420.897 193.685c0 .344.31.445.687.225l10.449-6.032a1.381 1.381 0 0 0 .688-1.016c0-.344-.31-.445-.688-.225l-10.449 6.032a1.381 1.381 0 0 0-.687 1.016zM-420.897 197.408c0 .344.31.445.687.225l10.449-6.032a1.381 1.381 0 0 0 .688-1.016c0-.344-.31-.445-.688-.225l-10.449 6.032a1.381 1.381 0 0 0-.687 1.016zM-433.785 208.579c0 .344.307.444.688.225l23.344-13.494a1.376 1.376 0 0 0 .688-1.016c0-.344-.31-.442-.688-.225l-23.344 13.494a1.373 1.373 0 0 0-.688 1.016zM-433.785 212.302c0 .344.307.444.688.224l23.344-13.477a1.381 1.381 0 0 0 .688-1.02c0-.34-.31-.44-.688-.221l-23.344 13.478a1.373 1.373 0 0 0-.688 1.016zM-433.785 216.027c0 .341.307.442.688.222l23.344-13.478a1.381 1.381 0 0 0 .688-1.018c0-.342-.31-.442-.688-.223l-23.344 13.478a1.373 1.373 0 0 0-.688 1.019z",
    style: {
      fill: "#d6d5f4",
      strokeWidth: 0.26458332
    },
    transform: "translate(487.522 -173.418)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)",
    style: {
      fill: "#d6d5f4"
    },
    d: "m378.27 160.74-28.43 124.3-158.42 91.46 28.43-124.29z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)",
    style: {
      fill: "#d6d5f4"
    },
    d: "M266.74 333.02v-92.18l-36.56 21.1v92.19z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 -11.957 -17.33)",
    style: {
      opacity: 0.2
    },
    d: "M266.74 333.02v-92.18l-36.56 21.1v92.19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-420.879 264.234c-.823-.614-8.755-6.675-12.787-15.346-4.292-9.218-4.287-19.97-4.287-24.016v-.127l28.755-16.6c0 4.082 0 14.851 4.31 24.1 3.94 8.468 11.568 14.452 12.777 15.368z",
    style: {
      fill: "#fff",
      strokeWidth: 0.26458332
    },
    transform: "translate(487.522 -173.418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-409.33 208.383c0 4.255.082 14.817 4.323 23.929 3.808 8.176 11.047 14.055 12.658 15.296l-28.522 16.467c-1.114-.839-8.747-6.8-12.674-15.232-4.286-9.191-4.286-19.923-4.286-23.963v-.05l28.49-16.45m.265-.457-29.02 16.756c0 3.807-.079 14.87 4.3 24.275 4.31 9.232 12.899 15.439 12.899 15.439l29.027-16.759s-8.599-6.207-12.896-15.438c-4.381-9.406-4.3-20.469-4.3-24.276z",
    style: {
      fill: "#d6d5f4",
      strokeWidth: 0.26458332
    },
    transform: "translate(487.522 -173.418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-409.33 208.383c0 4.255.082 14.817 4.323 23.929 3.808 8.176 11.047 14.055 12.658 15.296l-28.522 16.467c-1.114-.839-8.747-6.8-12.674-15.232-4.286-9.191-4.286-19.923-4.286-23.963v-.05l28.49-16.45m.265-.457-29.02 16.756c0 3.807-.079 14.87 4.3 24.275 4.31 9.232 12.899 15.439 12.899 15.439l29.027-16.759s-8.599-6.207-12.896-15.438c-4.381-9.406-4.3-20.469-4.3-24.276z",
    style: {
      opacity: 0.7,
      fill: "#fff",
      strokeWidth: 0.26458332
    },
    transform: "translate(487.522 -173.418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-412.349 213.542-9.176 5.292a1.302 1.302 0 0 0-.666 1.003c.013.336.333.431.711.212l9.179-5.292a1.302 1.302 0 0 0 .664-.99c-.016-.349-.33-.444-.712-.225zM-412.153 217.154l-9.176 5.292a1.222 1.222 0 0 0-.64.99c.03.325.362.412.74.192l9.18-5.291a1.206 1.206 0 0 0 .632-.987c-.027-.328-.355-.408-.736-.196zM-411.785 220.665l-9.179 5.292c-.378.22-.653.656-.608.97.045.316.391.398.772.178l9.179-5.292c.378-.22.648-.653.6-.968-.047-.315-.386-.4-.764-.18zM-411.235 224.07l-9.178 5.292c-.379.22-.64.648-.577.955.063.307.423.376.794.156l9.175-5.292c.381-.22.635-.645.572-.952-.064-.307-.394-.378-.786-.159zM-410.489 227.362l-9.178 5.291c-.379.22-.625.638-.53.932.096.293.458.36.837.14l9.178-5.292c.381-.22.62-.635.53-.931-.09-.296-.458-.36-.837-.14zM-409.52 230.534l-22.368 12.914c-.379.22-.609.627-.506.91.104.284.498.336.876.117l22.368-12.914c.381-.22.6-.625.497-.91-.103-.286-.502-.337-.867-.117zM-408.343 233.563l-22.365 12.915c-.381.22-.59.616-.463.886.127.27.529.312.915.093l22.368-12.915c.381-.22.585-.616.458-.886-.127-.27-.532-.31-.913-.093zM-406.875 236.45l-22.367 12.914c-.381.22-.57.606-.418.863.15.257.582.283.963.063l22.352-12.914c.378-.217.56-.6.41-.857-.151-.257-.57-.289-.94-.069zM-405.163 239.18l-22.365 12.912c-.38.22-.55.598-.378.839.172.24.624.265 1.005.042l22.365-12.914c.381-.22.545-.593.373-.836-.172-.244-.619-.262-1-.042zM-403.21 241.776l-22.368 12.912c-.378.22-.53.587-.339.817.19.23.66.241 1.04.022l22.368-12.92c.378-.22.53-.582.333-.812-.195-.23-.653-.246-1.034-.019zM-401.054 244.247l-22.36 12.912c-.38.22-.529.58-.307.794.223.214.694.22 1.072 0l22.368-12.915c.38-.22.513-.574.301-.793-.211-.22-.687-.215-1.074.003zM-398.672 246.61l-22.368 12.912c-.379.22-.503.571-.265.78.238.21.725.201 1.106-.018l22.35-12.915c.378-.22.497-.563.264-.775-.233-.211-.717-.204-1.087.016zM-424.85 220.763l-10.552 6.085c.116 3.824.553 9.337 2.151 14.891l10.554-6.085c-1.6-5.554-2.037-11.07-2.153-14.891z",
    style: {
      fill: "#d6d5f4",
      strokeWidth: 0.26458332
    },
    transform: "translate(487.522 -173.418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-424.85 220.763-10.552 6.085c.116 3.824.553 9.337 2.151 14.891l10.554-6.085c-1.6-5.554-2.037-11.07-2.153-14.891z",
    style: {
      opacity: 0.8,
      fill: "#fff",
      strokeWidth: 0.26458332
    },
    transform: "translate(487.522 -173.418)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.2a94690789f8c77932ddcc0edc81fbca.svg";
export { ForwardRef as ReactComponent };